import { Color } from "@repo/app-types/constants/colors";
import type { CoachingGoalProgressPill } from "@repo/app-types/helpers/coachingGoalProgress";
import type { FC } from "react";
import { Size } from "../helpers/helpers.js";
import { Pill, type PillColor } from "../Pills/pill.js";

const pillColors: Record<CoachingGoalProgressPill["tone"], PillColor> = {
  muted: Color.Gray,
  danger: Color.Red,
  success: Color.Green,
};

/**
 * The Goal-progress standing pill (No data / Behind / On track / Near goal /
 * Goal met). Shared by the team table's Goal progress cells and the filter
 * menu's options so the filter choices look exactly like the values they
 * select.
 */
export const CoachingGoalPill: FC<{ pill: CoachingGoalProgressPill }> = ({
  pill,
}) => (
  <Pill color={pillColors[pill.tone]} size={Size.SMALL} label={pill.label} />
);
